/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

window.addEventListener("load", (event) => {
   $('.yotpo-reviews-carousel').parents('section').hide();
    $('.quntity_button').click(function(){
    let quntity = $(this).attr('data-quntity');
    $('#quantity').val(quntity); 
    });
     function change_review(){
         let data_stop = $('body').attr('data-stop');
       let condtion = false;
       if(data_stop == 'implement'){
         condtion = true;
       }else if(data_stop == 'test' && $('body').hasClass('rl-ab001-1')){
         condtion = true;
       }
        if(condtion){
    setTimeout(function(){
  if($('.title_price_cover__container .yotpo-small .yotpo-display-wrapper').length == 0){
   let all_review_count = $('.yotpo-num-of-reviews').text();
   let start_html = $('.yotpo-review-stars').html();
  $('.title_price_cover__container .yotpo.carousel-reviews-bottom-line').remove();
  $('.title_price_cover__container').append('<div class="yotpo carousel-reviews-bottom-line"><div class="yotpo-review-stars text-m">'+ start_html + '</div><span class="yotpo-num-of-reviews">4.67/5 ( Based on '+all_review_count+')</span></div>');
    $('.product_review-color.app_covers').hide();
    $('.yotpo-reviews-carousel').parents('section').show();
  }else{
     $('.product_review-color.app_covers').show();
     $('.yotpo-reviews-carousel').parents('section').hide();
  }    
    }, 1800);
     }
     }
     function chnage_sub(){
       $('.custom_message').remove();  
       let data_stop = $('body').attr('data-stop');
       let condtion = false;
       if(data_stop == 'implement'){
         condtion = true;
       }else if(data_stop == 'test' && $('body').hasClass('rl-ab001-1')){
         condtion = true;
       }
        if(condtion){
    setTimeout(function(){
      let sub_data = $('body').attr('data-sub-text');
        if(sub_data){   
           $('.custom_message').remove();     
           $('.yotpo-select-wrapper').append('<p class="custom_message">'+sub_data+'</p>');  
         }
        $('.yotpo-radio-container:eq(1) .yotpo-radio-label').trigger('click');
       }, 1000);
     }
     }
   function change_addtocart(){
     let data_stop = $('body').attr('data-stop-2');
       let condtion = false;
       if(data_stop == 'implement'){
         condtion = true;
       }else if(data_stop == 'test' && $('body').hasClass('rl-ab002-1')){
         condtion = true;
       } 
        if(condtion){
       if($('.yotpo-plans-and-policy-wrapper').length > 0 && $('.quntity_button').length > 0){
          $('.quantity_btn-wrapper').css('display','flex');
          $('.temp-product button#AddToCart').hide();
          $('.product-form__quantity').hide();
          $('.yotpo-plans-and-policy-wrapper').hide();
      }else{
         $('.quantity_btn-wrapper').hide();
        $('.temp-product button#AddToCart').show();
         $('.product-form__quantity').show();
         $('.yotpo-plans-and-policy-wrapper').show();
      }
          
   }
   }
  chnage_sub();
  change_review();
  change_addtocart();
   const targetNode = document.body;
  const config = { attributes: true };
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes") {
        if (targetNode.classList.contains("rl-ab001-1")) {
          chnage_sub();
        }
          if (targetNode.classList.contains("rl-ab002-1")) {
          change_addtocart();
        }
      }
     }  
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
if (!!document.querySelector(".block-swatch-list .block-swatch") === true){
  var length_all = document.querySelectorAll('.block-swatch-list .block-swatch').length;
  var length_disabled = document.querySelectorAll('.block-swatch-list .block-swatch.is-disabled').length;
    console.log(length_all);console.log(length_disabled);
  if ( length_all == length_disabled ){
    document.head.insertAdjacentHTML('beforeend', '<style>.block-swatch.is-disabled{display:block !important;}</style>')
  }
}
// Correction bugs Drop Down
if (!!document.querySelector('product-variants div[data-selector-type="dropdown"]') === true){
  var dropdown = document.querySelectorAll('product-variants div[data-selector-type="dropdown"]');
  for (var i = 0; i < dropdown.length; i++) {
      dropdown[i].querySelector('.select-wrapper combo-box .combo-box__option-list>button:not(.is-disabled)').click();
      var width_list = dropdown[i].querySelector('.select-wrapper combo-box .combo-box__option-list').offsetWidth;
      dropdown[i].querySelector('button.select').style.cssText = "width: "+ (width_list + 50) +"px;";
  }
}
});




// Prix dans le panier (avec et sans Yotpo)
window.addEventListener("load", (event) => {

  if (!!document.querySelector(".yotpo-selling-plans-wrapper") === true){
    var price = document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-radio-container.yotpo-selected .yotpo-subscription-label-price").innerHTML;
    document.querySelector("#AddToCart .loader-button__text .price-atc").innerHTML = price;
    document.querySelector("#StickyAddToCart .loader-button__text .price-atc").innerHTML = price;

    document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans>div:first-child .yotpo-radio-label").onclick = function() {
      setTimeout(function () {
        var quantity = parseInt(document.querySelector(".product-form .quantity-selector__input").value);
        var price = parseFloat(document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans>div:first-child .yotpo-subscription-label-price").innerHTML.replace('€', '').replace(',', '.')).toFixed(2);
        document.querySelector("#AddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
        document.querySelector("#StickyAddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
      }, (200));
    };

    document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans>div:last-child .yotpo-radio-label").onclick = function() {
      setTimeout(function () {
        var quantity = parseInt(document.querySelector(".product-form .quantity-selector__input").value);
        var price = parseFloat(document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans>div:last-child .yotpo-subscription-label-price").innerHTML.replace('€', '').replace(',', '.')).toFixed(2);
        document.querySelector("#AddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
        document.querySelector("#StickyAddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
      }, (200));
    };
    
    var labelYotpo = document.querySelectorAll('.yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-option');
    for (var i = 0; i < labelYotpo.length; i++) {
      labelYotpo[i].addEventListener('click', function(event) {
          setTimeout(function () {
            var quantity = parseInt(document.querySelector(".product-form .quantity-selector__input").value);
            var price = parseFloat(document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans>div:last-child .yotpo-subscription-label-price").innerHTML.replace('€', '').replace(',', '.')).toFixed(2);
            document.querySelector("#AddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
            document.querySelector("#StickyAddToCart .loader-button__text .price-atc").innerHTML = (quantity * price) + "€";
          }, (200));
      });
    }
  }

  if (!!document.querySelector(".quantity-selector__input") === true){
    var quantityProduct = document.querySelectorAll('.quantity-selector__button');
    for (var i = 0; i < quantityProduct.length; i++) {
      quantityProduct[i].addEventListener('click', function() {
        setTimeout(function () {
          var quantity = parseInt(document.querySelector(".product-form .quantity-selector__input").value);
          if (!!document.querySelector(".yotpo-selling-plans-wrapper") === true){
            var price = parseFloat(document.querySelector(".yotpo-widget-subscriptions-add-to-cart .yotpo-radio-container.yotpo-selected .yotpo-subscription-label-price").innerHTML.replace('€', '').replace(',', '.')).toFixed(2);
          }else{
            debugger
            var price = parseFloat(document.querySelector(".title_price_cover span.price.price--large").innerHTML.replace(/\D/g, '')).toFixed(2) / 100;
          }
          document.querySelector("#AddToCart .loader-button__text .price-atc").innerHTML = (quantity * price).toFixed(2) + "€";
          document.querySelector("#StickyAddToCart .loader-button__text .price-atc").innerHTML = (quantity * price).toFixed(2) + "€";
        }, (100));
      });
    }
  }
});


// More/less
if (!!document.querySelector(".page-header__text-wrapper>div") === true){
  var height = document.querySelector(".page-header__text-wrapper>div").offsetHeight;
  if (height > 80){
    document.querySelector(".page-header__text-wrapper>div").classList.add("cache");
    document.querySelector(".page-header__text-wrapper>div").insertAdjacentHTML('afterend', '<span class="more-less">Leggi di più</span>');
    document.querySelector(".page-header__text-wrapper>.more-less").onclick = function() {
      if ( document.querySelector(".page-header__text-wrapper>div").classList.contains("cache") === true ){
        document.querySelector(".page-header__text-wrapper>div").classList.remove("cache");
        document.querySelector(".page-header__text-wrapper>.more-less").innerHTML = "Chiudi";
      }else{
        document.querySelector(".page-header__text-wrapper>div").classList.add("cache");
        document.querySelector(".page-header__text-wrapper>.more-less").innerHTML = "Leggi di più";
      }
    };
  }
}

// Check Sample Cart
setTimeout(function () {
  if (document.querySelectorAll("#mini-cart-form .line-item").length == 1 && !!document.querySelector("#mini-cart-form .line-item__remove-button.sample-remove") === true) {
    document.querySelector("#mini-cart-form .line-item__remove-button.sample-remove").click();
  }
}, 2000);


// Smooth scrolling not supported, add JavaScript
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const offset = 132; // You can adjust this value as needed
      const targetPosition = targetElement.offsetTop - offset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  });
});

// Languge Switcher Code

// const checkLangInterval = setInterval(function () {
//   var windowWidth = window.innerWidth;
//   if (windowWidth < 1025) {
//     const injectedElement = document.querySelector('.locale-selectors__container');
//     if (injectedElement && !injectedElement.classList.contains('moved')) {
//       let mobileMenuContainer = document.querySelector('#mobile-menu-drawer .drawer__footer');
//       mobileMenuContainer.appendChild(injectedElement);
//       injectedElement.classList.add('moved');
//       console.log('lang switcher element injected')
//       clearInterval(checkLangInterval);
//     }
//   } else {
//     clearInterval(checkLangInterval);
//   }
// }, 500);

/*
* ------------------------------------------------------------------------------------------------------------
* GLOBAL DISCOUNT CODE - TAMARA DEV(SJ)
* ------------------------------------------------------------------------------------------------------------
*/

window.calculateDiscount = function () {
  const currentHour = new Date().getHours();
  const discountTiers = [
    { startHour: 0, endHour: 8, discount: 25 }
  ];
  const isNightHour = currentHour >= 0 && currentHour < 8;
  if (isNightHour) {
    const currentTier = discountTiers.find(tier => {
      return currentHour >= tier.startHour && currentHour < tier.endHour;
    });
    if (currentTier) {
      return currentTier.discount;
    }
  }
  return 0;
}

window.calculateDiscountedPrice = function(productPrice, discount) {
  const formattedProductPrice = productPrice/100
  const discountedPrice = formattedProductPrice - (formattedProductPrice * discount / 100);
  const formattedPrice = discountedPrice.toFixed(2);
  return `${formattedPrice.replace('.', ',')}€`;
}

window.calculateDiscountedAmount = function(productPrice, discount) {
  const formattedProductPrice = productPrice/100
  const discountedPrice = (formattedProductPrice * discount / 100);
  const formattedPrice = discountedPrice.toFixed(2);
  return `${formattedPrice.replace('.', ',')}€`;
}

window.isPromoActive = function() {
  const currentHour = new Date().getHours();
  return currentHour >= 0 && currentHour < 8;
}


window.heroBannerTimer = function(show_message_from_hour, show_message_to_hour) {
  return {
      compareHours() {
          let currentHour = new Date().getHours();
          if (show_message_from_hour < show_message_to_hour) {
              return currentHour >= show_message_from_hour && currentHour < show_message_to_hour;
          } else if (show_message_from_hour > show_message_to_hour) {
              return currentHour >= show_message_from_hour || currentHour < show_message_to_hour;
          } else {
              return true;
          }
      }
  }

}


const checkGiftAdded = async function (items, id) {
  const response = await fetch("/cart.js");
  const data = await response.json();      
  const matched = data.items.filter((item) => item.id == id && item.properties._isGift == 1);
  if (matched.length > 0) {
    return true;
  } else {
    return false;
  }
}
const addMultipleItemsForProgressbar = async function(items){
  let formData = {
     'items': items
    };
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
    
}

let isConfitthre1 = false;
function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
}
let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

async function updateProgessbar(){
  const response = await fetch("/cart.js");
    const cart = await response.json();
  if($('.custom-cart-gift-item-template').length > 0){
    const htmlContent = $('.custom-cart-gift-item-template').html();
    if($(".custom-gift-bar-main .custom-gift-bar-wrapper").length <= 0){
      $(".custom-gift-bar-main").html(htmlContent);
    }
    if(cart.item_count > 0){
       $(".custom-gift-bar-main").removeClass("hide");
    }
   
    
    const progressBarElement = $(".custom-gift-bar-main").find(".custom-gift-bar-progress-wrapper .p-progress-bar");
    const threshold = +progressBarElement.data("threshold"); console.log("LLS threshold:" + threshold);
     const threshold2 = +progressBarElement.data("threshold2"); console.log("LLS threshold:" + threshold2);
    const vid = $(".custom-gift-bar-main .custom-gift-bar-wrapper").data("vid");
    const vid2 = $(".custom-gift-bar-main .custom-gift-bar-wrapper").data("vid2");
    const enbabledSecond = $(".custom-gift-bar-main .custom-gift-bar-wrapper").data("secondenabled");
    const gift1ProductPriceInCent = +progressBarElement.data("price1");
   const gift2ProductPriceInCent = +progressBarElement.data("price2");
    if(enbabledSecond == true){
      
      let isgift1Added = false;
      let isGift2Added = false;
      isgift1Added = await checkGiftAdded(cart.items, vid);
      isGift2Added = await checkGiftAdded(cart.items, vid2);
      let cartTotalinCent = cart.total_price;

      /*if (isgift1Added) {
        cartTotalinCent = cartTotalinCent - gift1ProductPriceInCent;
      }
      if (isGift2Added) {
        cartTotalinCent = cartTotalinCent - gift2ProductPriceInCent;
      }*/
      
      let amount = cartTotalinCent / 100;
      let percentage = (amount / threshold2) * 100;
      
      let maxAmount = threshold;
      
      if (amount <= threshold) {
        maxAmount = threshold;
      } else if (amount > threshold && amount <= threshold2) {
        maxAmount = threshold2;
      }
      
      if(amount <= threshold){
        percentage = ((amount / (threshold + threshold2)) * 100)+25;
        console.log(percentage,"percentage first");
        if(amount < threshold && percentage > 59){
            percentage = percentage-5;
        }
        /*if(percentage > 50){
          percentage = percentage-35;
        }*/
      }else if(amount > threshold && amount < threshold2 ){
        percentage = ((amount / (threshold + threshold2)) * 100);
        console.log(percentage,"percentage se");
        if(percentage <= 99.99){
            percentage = 75.82;
        }
        /*if(percentage < 80){
          percentage = 71.82;
        }*/
      }else if(amount >= threshold2){
        percentage = 100;
      }
      if(amount > threshold2){
        let items = [];
        if(vid != '' && isgift1Added == false){
          items.push(
            {
              'id': vid,
              'quantity':1,
              'properties':{
                '_isGift':1
              }
            }
          );
            const el = document.querySelector(".custom-gift-bar-main .first-threshold .bar-icon-wrapper");
           progressConfetti(el);
        }
        if(vid2 != '' && isGift2Added == false){
          
          items.push(
            {
              'id': vid2,
              'quantity':1,
              'properties':{
                '_isGift':1
              }
            }
          );
           const el = document.querySelector(".custom-gift-bar-main .second-threshold .bar-icon-wrapper");
           progressConfetti(el);
        }
        $(".custom-gift-bar-main .second-threshold .position-bar-box-container").addClass("activated-gift");
        if(items.length > 0){
          await addMultipleItemsForProgressbar(items);
        }
       
      }else{
        if ((amount >= threshold && amount< threshold2) && isgift1Added == false ) {
          if(vid != ""){
             const a1 = await checkGiftProductOnCart(vid, cart,1);
          }
          if( $(".custom-gift-bar-main .first-threshold .position-bar-box-container .activated-gift").length <= 0){
            $(".custom-gift-bar-main .first-threshold .position-bar-box-container").addClass("activated-gift");
            const el = document.querySelector(".custom-gift-bar-main .first-threshold .bar-icon-wrapper");
            if(isgift1Added == false){
               progressConfetti(el);
            }
          }
          
        }else if (amount >= threshold2 && isGift2Added == false) {
         if(vid2 != ""){
               const a2 = await checkGiftProductOnCart(vid2, cart,1);
          }
          $(".custom-gift-bar-main .second-threshold .position-bar-box-container").addClass("activated-gift");
          const el = document.querySelector(".custom-gift-bar-main .second-threshold .bar-icon-wrapper");
          
          if(isGift2Added == false){
             progressConfetti(el);
          }
        }
      }
      
      
     
      if(amount < threshold){
        const sippingAmount = (threshold - amount)*100;
        $(".custom-gift-bar-main .first-thrshold-content-div").removeClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").addClass('hide');
        $(".custom-gift-bar-main .first-thrshold-content-div").find(".threshold-text-content span.custom-amount").text(formatMoney(sippingAmount,currencyFormat));
        $(".custom-gift-bar-main .first-thrshold-content-div").find(".free-text-content").addClass('hide');
        $(".custom-gift-bar-main .first-thrshold-content-div").find(".threshold-text-content").removeClass('hide');
         $(".custom-gift-bar-main .first-threshold .position-bar-box-container").removeClass("activated-gift");
        $(".custom-gift-bar-main .second-threshold .position-bar-box-container").removeClass("activated-gift");
      }else if(amount > threshold && amount < threshold2 ){
        const sippingAmount = (threshold2 - amount)*100;
        $(".custom-gift-bar-main .first-threshold .position-bar-box-container").addClass("activated-gift");
        $(".custom-gift-bar-main .first-thrshold-content-div").addClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").removeClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").find(".threshold-text-content span.custom-amount").text(formatMoney(sippingAmount,currencyFormat));
        $(".custom-gift-bar-main .second-thrshold-content-div").find(".free-text-content").addClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").find(".threshold-text-content").removeClass('hide');
      }else if(amount >= threshold2){
        $(".custom-gift-bar-main .first-threshold .position-bar-box-container").addClass("activated-gift");
        $(".custom-gift-bar-main .second-threshold .position-bar-box-container").addClass("activated-gift");
        
        $(".custom-gift-bar-main .first-thrshold-content-div").addClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").removeClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").find(".free-text-content").removeClass('hide');
        $(".custom-gift-bar-main .second-thrshold-content-div").find(".threshold-text-content").addClass('hide');
      }
      if (amount < threshold2 && isGift2Added == true) {
        const ad1 = await checkGiftProductOnCart(vid2, cart,0);
      }
                                       
      if (amount < threshold && isgift1Added == true) {
         const ad2 = await checkGiftProductOnCart(vid, cart,0);
      }
       progressBarElement.find(".p-progress").css("width",`${percentage}%`);
      //localStorage.setItem('progrssbarsimplehtml', JSON.stringify($(".custom-gift-bar-main").html()));
      
    }else{
      let isGiftOncart = false;
      let giftPrice = 0;
      for(let i in cart.items){
        if(cart.items[i].id == vid){
          isGiftOncart = true;
          giftPrice = cart.items[i].final_line_price; 
          break;
        }
      }
      const cartTotalIncent = (cart.total_price - giftPrice); 
      const amountIncent = ( threshold * 100); 
      const sippingAmount = (amountIncent - cartTotalIncent);
      const cartTotal = cartTotalIncent/100;
      const goal = threshold;
      let progress = ( (cartTotal/goal) * 100).toFixed(0);
     
      if(amountIncent <= cartTotalIncent){
        /*$(".custom-gift-bar-main").find(".free-text-content").removeClass('hide');
        $(".custom-gift-bar-main").find(".threshold-text-content").addClass('hide');*/
        $(".custom-gift-bar-main .position-bar-box-container").addClass("activated-gift");
        $(".custom-gift-bar-main").find(".free-text-content").removeClass('hide');
        $(".custom-gift-bar-main").find(".threshold-text-content").addClass('hide');
        if(vid != ""){
           checkGiftProductOnCart(vid, cart,1);
        }
        
        const el = document.querySelector(".custom-gift-bar-main .bar-icon-wrapper");
        if(isGiftOncart == false){
           progressConfetti(el);
        }
      }else{
        $(".custom-gift-bar-main").find(".threshold-text-content span.custom-amount").text(formatMoney(sippingAmount,currencyFormat));
        $(".custom-gift-bar-main").find(".threshold-text-content").removeClass('hide');
        $(".custom-gift-bar-main").find(".free-text-content").addClass('hide');
        
        $(".custom-gift-bar-main .position-bar-box-container").removeClass("activated-gift");
         if(vid != ""){
           checkGiftProductOnCart(vid,cart,0);
         }
        progress = progress-20;
      }
      if(progress > 100){
        progress = 100;
      }
     progressBarElement.find(".p-progress").css("width",`${progress}%`);
       //localStorage.setItem('progrssbarsimplehtml', JSON.stringify($(".custom-gift-bar-main").html()));
     }
   
  }
}
function progressConfetti(el){
   return;
  var canvas = document.createElement("canvas");
      var container = el;
      canvas.width = 600;
      canvas.height = 600;
     container.appendChild(canvas);
      var confetti_button = confetti.create(canvas);
      confetti_button({
        particleCount: 200,
        spread: 200,
        startVelocity: 15,
        scalar: 0.9,
        ticks: 90
      })
      confetti_button().then(function () { container.removeChild(canvas) });
}

async function checkGiftProductOnCart(vid,cart, qty){
  // hideCartActionButtons();
    const response = await fetch("/cart.js");
    const data = await response.json();
      
  let isGiftOncart = false;
  let ItemKey = ""; 
  const matched = data.items.filter((item) => item.id == vid && item.properties._isGift == 1);
  if (matched.length > 0) {
    isGiftOncart = true;
    ItemKey = matched[0].key;
  } else {
    isGiftOncart= false;
  }
  if(isGiftOncart == true &&  qty == 0){
     fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: vid.toString(),
        quantity: 0
      })
    })
    .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }else if(isGiftOncart == false && qty == 1){
    let formData = {
     'items': [{
      'id': vid,
      'quantity':qty,
      'properties':{
        '_isGift':1
      }
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
       document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((error) => {
      console.error('Error:', error);
    });  
  }
  return true;
}
class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.shadow = this.attachShadow({ mode: 'open' });
      this.countdownElement = null;
    }

    connectedCallback() {
      //this.endDate = new Date(this.getAttribute('end-date'));
      this.timezone = this.getAttribute('timezone') || 'UTC';
      this.endDate = new Date(this.getAttribute('end-date'));
      this.render();
      this.updateCountdown();

      //setInterval(() => this.updateCountdown(), 1000);
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    render() {
      this.shadow.innerHTML = `
        <div id="countdown"></div>
      `;
      this.countdownElement = this.shadow.getElementById('countdown');
    }

    updateCountdown() {
      const now = new Date();
      //const timeRemaining = this.endDate - now;
       const timeRemaining = new Date(this.endDate) - new Date(now);

      if (timeRemaining > 0) {
        //const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        if(hours < 10){
          hours = `0${hours}`;
        }
         if(minutes < 10){
          minutes = `0${minutes}`;
        }
         if(seconds < 10){
          seconds = `0${seconds}`;
        }
        this.countdownElement.textContent = `${hours}:${minutes}:${seconds}`;
      } else {
         $(".custom-gift-bar-main").remove();
        this.countdownElement.textContent = 'Countdown expired';
         clearInterval(this.interval);
      }
    }
  }

  customElements.define('custom-countdown', CountdownTimer);

document.addEventListener("DOMContentLoaded", (event) => {
 /*document.documentElement.addEventListener("cart:updated",function(event){
   console.log(event,"cartUpdated");
   setTimeout(()=>{
     updateProgessbar();
   },100);
 });*/
  document.documentElement.addEventListener("cart:contentupdated",function(event){
    console.log(event,"cart:contentupdated");
     updateProgessbar();
 });
});

